export default __webpack_public_path__ + "static/media/avatar-placeholder.2d067b73.svg";